import { MenuItem } from '@mui/material';
import { SelectBox } from '@vxui/components';
import { Dispatch, FC, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { SimplifiedTemplate } from '../profilesTable.types';

type TableTemplateFilter = {
  templates: SimplifiedTemplate[];
  state: [string, Dispatch<SetStateAction<string>>];
};

export const TableTemplateFilter: FC<TableTemplateFilter> = ({ templates, state }) => {
  const [template, setTemplate] = state;

  const { t } = useTranslation();

  return (
    <SelectBox
      value={template}
      onChange={a => setTemplate(a.target.value)}
      size="small"
      allowEmpty
      placeholder={t('table.allRows')}
      fullWidth={false}
      sx={{ width: '260px' }}
    >
      {templates.map(template => (
        <MenuItem key={template.id} value={template.id}>
          {template.name}
        </MenuItem>
      ))}
    </SelectBox>
  );
};
